<template>
  <div :class="['ms-form', 'ms-form--narrow', { purpose: this.data?.body?.purpose }]">
    <q-form @submit="this.onSubmit">
      <div class="ms-form-grid ms-form-grid--single">
        <CustomUploader
          :value="formData.photo"
          :on-change="(value) => onChange('photo', value)"
          label="Фотография"
          :fullWidth="true"
        />
        <CustomInput
          label="Порядковый номер"
          :required="true"
          type="number"
          :showClearIcon="false"
          :value="this.formData.order_num"
          :controls="true"
          @change_input="(value) => onChange('order_num', value)"
        />
        <div class="showroom-photo__flags">
          <CustomCheckbox
            :binary="true"
            label="Активный"
            :value="this.formData.is_active"
            @change="(value) => onChange('is_active', value)"
          />
          <CustomCheckbox
            :binary="true"
            label="Главная фотография"
            :value="this.formData.is_main"
            @change="(value) => onChange('is_main', value)"
          />
        </div>
      </div>
      <CustomModalFooter :btn-loading="this.btnLoading" />
    </q-form>
  </div>
</template>

<script>
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomUploader from "@/components/form/CustomUploader";
import CustomCheckbox from "@/components/form/CustomCheckbox";
import CustomInput from "@/components/form/CustomInput";

export default {
  name: "add-showroom-photo",
  components: { CustomModalFooter, CustomUploader, CustomCheckbox, CustomInput },
  props: ["data"],
  data() {
    return {
      btnLoading: false,
      formData: {
        photo: "",
        front_show_room_id: this.data?.body?.front_show_room_id || "",
        front_show_room_photo_id: this.data?.body.front_show_room_photo_id || "",
        order_num: this.data?.body.order_num || "",
        is_active: this.data?.body.is_active || 1,
        is_main: this.data?.body.is_main || 0,
      },
    };
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value;
    },
    async onSubmit() {
      this.btnLoading = true;
      if (this.formData.photo) {
        this.formData.photo = this.formData.photo[0];
      }
      await this.data?.onSubmit(this.formData);
      this.btnLoading = false;
    },
  },
};
</script>

<style scoped lang="scss">
// Сетка — общая (ms-form-* в theme.scss)
.showroom-photo__flags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 16px;
  margin-left: -8px;
}
</style>
